<template>
	<div>
		<loading :active="loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<div class="row">
			<div class="col-md-12">
				<div class="form-group" :class="{ 'has-error' : errors.has('key') }">
					<label class="control-label">Key</label>
					<input
						v-validate="'required'"
						name="key"
						data-vv-as="Key"
						v-model="stripe.key"
						type="text"
						class="form-control">
					<small v-show="errors.has('key')" class="form-text text-danger">
						{{ errors.first('key') }}
					</small>
				</div>
			</div>
			<div class="col-md-12">
				<div class="form-group" :class="{ 'has-error' : errors.has('secret') }">
					<label class="control-label">Secret</label>
					<input
						v-validate="'required'"
						name="secret"
						data-vv-as="Secret"
						v-model="stripe.secret"
						type="text"
						class="form-control">
					<small v-show="errors.has('secret')" class="form-text text-danger">
						{{ errors.first('secret') }}
					</small>
				</div>
			</div>
			<div class="col-md-12">
				<div class="form-group" :class="{ 'has-error' : errors.has('status_id') }">
					<label for="status_id">Estado</label>
					<select
						v-validate="'required'"
						name="status_id"
						data-vv-as="Secret"
						v-model="stripe.status_id"
						id="status_id"
						class="form-control">
						<template v-if="statuses">
							<option v-for="status in statuses" :value="status.id">{{status.name}}</option>
						</template>
					</select>
					<small v-show="errors.has('status_id')" class="form-text text-danger">
						{{ errors.first('status_id') }}
					</small>
				</div>
			</div>
			<div class="col-md-12">
				<div class="btn-group pull-right">
					<button @click="validate" type="button" class="btn btn-default">
						Guardar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'statuses'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				loading: false,
				stripe: {
					key: null,
					secret: null,
					status_id: 2,
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.loading = true
				this.$http.get('admin/api/keys/stripe')
				.then(response => {
					this.loading = false
					if(response.body) {
						this.stripe= response.body
					}
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.save()
					}
					return result
				})
			},
			save() {
				if(this.stripe.id) {
					this.update()
				} else {
					this.store()
				}
			},
			store() {
				this.loading = true
				this.$http.post('admin/api/keys/stripe', this.stripe)
				.then(response => {
					this.loading = false
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/api/keys/stripe/' + this.stripe.id, this.stripe)
				.then(response => {
					this.loading = false
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Apis/Stripe.vue